namespace Gordic.Epk.WebControls {

    // detail:
    // 1. zvětšit délku swipu při kterém začnu reagovat
    // 2. zkontrolovat kliky na náhledech
    // 3. věc ve statusbaru - skrývá se celá i když je se tam nevejde jen z části
    // 4. zapnout vyřízení
    // 5. možná swipe nahradím za tlačítka :/
    // 6. vyřízení žádosti a předchod na grid či další detail

    // seznam:
    // 1. ikony
    // 2. hromadné vyřízení
    // 3. *optimalizace stylů


    // napojení detailu
    // nopojení nových ikon

    const { gcontent } = Decorators;

    @gcontent
    export class GEpkDetailMobile extends GContentBase<GEpkDbParamsNew> {

        /** identifikátor dokumentu /žádosti */
        Ixp: string;
        /** pořadové číslo žádosti */
        SerCislo: number;
        /** příznak přenačtení detailu žádosti */
        private Reload: boolean;
        /** načtený řádek žádosti */
        row: Gordic.Wfl.Interface.GPodpisovaKnihaDto;
        /** identifikátor funkce aktuálně přihlášeného uživatele */
        private ixsFunPrihlasenehoUzivatele: string;
        /** třída obecných metod */
        private common: GEpkCommon;

        // ---------

        public onContentReady() {

            this.showFlashOnStart();
            this.showNahled();

            //this.statusBar(this.getStatusbarParams());
            this.commandBar(this.getCommandbarParams());
            this.createMenubar();

            this.setInitValues();
            this.common = new GEpkCommon();
            this.common.preSetStates({
                cnt: this,
                row: this.row,
                sessionIxsFunFlag: this.common.isRequestMineAndActive(this.row, this.ixsFunPrihlasenehoUzivatele),
                setChecks: true,
                multi: false
            });

        }


        /**
         * nastavení vstupních hodnot
         */
        private setInitValues() {

            //this.fileInfo = new EpkFileInfo();

            this.signing = false;

            this.menuSchvalit = { enabled: false };
            this.menuPosoudit = { enabled: false };
            this.menuZamitnout = { enabled: false };
            this.pridatVyrizSoubor = { enabled: false };

            //#region -- OBRAZ --

            this.podepsat = { enabled: false, checked: false, visible: true };
            this.schvalit = { enabled: false, checked: false, visible: true };
            this.podepsataschvalit = { enabled: false, checked: false, visible: true };
            this.posoudit = { enabled: false, checked: false, visible: true };
            this.vzitnavedomi = { enabled: false, checked: false, visible: true };
            // splnit (specialita pro Ukrajinu)
            this.splnit = { enabled: false, checked: false, visible: true };
            this.rozhodnout = { enabled: false, checked: false, visible: true }

            this.casoveRazitko = { enabled: false, checked: false, visible: true };
            this.zkonvertovat = { enabled: false, checked: false, visible: true };

            //#endregion

            //#region -- specialita MD --

            this.pridelit = new IEpkCheckBoxSetting(false, false, true);
            this.predat = new IEpkCheckBoxSetting(false, false, true);
            this.schvaleniVyrizeniSpisu = new IEpkCheckBoxSetting(false, false, true);

            //#endregion

            //#region -- PŘÍLOHY --

            this.podepsatPrilohy = { enabled: false, checked: false, visible: false };
            this.casoveRazitkoPriloha = { enabled: false, checked: false, visible: false };
            this.zkonvertovatPrilohy = { enabled: false, checked: false, visible: false };
            this.podepsatPrilohyNePDF = { enabled: false, checked: false, visible: false };

            //#endregion

        }

        /** nastavení pro procházení detailů pomocí šípek */
        private listControls_setup: any;

        private getSettlementParams(params: MenuParams[]) {

            params.push({
                favorite: true,
                action: this.actions.add(new GAction({
                    name: "actVyrizeni",
                    enabled: false,
                    icon: "fa-check-circle g-state-text g-state-success",
                    caption: "jres:32000064",							//RC 32000064 : Nelze vyřídit
                    run: () => {

                        if (this.row === null)
                            return;

                        var dto = this.getParams(Gordic.Wfl.Interface.GWflczpvEnum.Povoleno, false);
                        if (dto != null) {
                            const done = () => {
                                this.selectTypeOfClose();
                            };
                            const list: Wfl.Interface.GEpkCompleteConfigDto[] = [];
                            list.push(dto);
                            new Settlement({ cnt: this, done: done, row: this.row }).run(list);
                        }

                    }
                }))
            });

            params.push({
                favorite: true,
                visiblePriority: 90,
                action: this.actions.add(new GAction({
                    name: "actVratit",
                    enabled: false,
                    icon: "fa-times-circle g-state-text g-state-error",
                    caption: "jres:32000040", //RC 32000040 : Vrátit k přepracování
                    tooltip: "jres:32000364", //RC 32000364 : Provede zamítnutí požadavku. V závislosti na stavu schvalovacího procesu může dojít k ukončení celého procesu.
                    run: () => {

                        if (this.row === null)
                            return;

                        var dto = this.getParams(Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani, false);
                        if (dto != null) {
                            const done = () => {
                                this.selectTypeOfClose();
                            };
                            const list: Wfl.Interface.GEpkCompleteConfigDto[] = [];
                            list.push(dto);
                            new Settlement({ cnt: this, done: done, row: this.row }).run(list);
                        }

                    }
                }))
            })

        }

        private createMenubar() {

            var GinListControlsObject = (Gin.DetailBuilderComponents as any).GinListControls.create(this);
            this.actions.addRange(GinListControlsObject.actions);
            $.extend(this, GinListControlsObject.contentExtensions);


            var params: MenuParams[] = [];

            this.getSettlementParams(params);

            params.push({
                visiblePriority: 10,
                align: "opposite",
                action: this.actions.add(new GAction({
                    name: "actDetailDokument",
                    run: () => {
                        var options = {
                            DetailDto: { ixp: this.row.ixp! }
                        };
                        Gordic.Wfl.Dialogs.DetailDokumentuSpisu(this, options, Gordic.Gin.Globals.Enums.ModOtevreni.navigate);
                    },
                    icon: "gi-detail",
                    caption: "jres:32000658",//RC 32000658 : Detail dokumentu/spisu
                })),
                favorite: false
            });

            this.menuBar(params.concat(GinListControlsObject.menubar));

            //#region ** vytvořit šipky na procházení detailu **

            this.listControls_setup({
                rowToDto: function (gridState) {
                    return {
                        Ixp: gridState.currentRow.data.ixp,
                        SerCislo: gridState.currentRow.data.ser_cislo,
                    };
                },
                //template pro tooltip na šipce následující
                nextItemTemplate: "Následující detail: {ixp}",
                //template pro tooltip na šipce předchozí
                prevItemTemplate: "Předchozí detail: {ixp}"
            });
            (this as any).listControls_updateCaptions();

            //#endregion

        }

        private showFlashOnStart() {

            //this.hideFlash("idInitialFlash");

            //var label = "";
            //if (this.row.vec != null && this.row.vec !== "" && this.row.typ_pozad_pod_txt != null && this.row.typ_pozad_pod_txt !== "") {
            //    //RC 32000952 : Věc
            //    //RC 32000445 : Upřesnění požadavku
            //    label += "jres:32000952, jres:32000445 : ";
            //    label += "\"" + this.row.vec + "\", ";
            //    label += "\"" + this.row.typ_pozad_pod_txt + "\"";

            //    this.showFlash({
            //        id: "idInitialFlash",
            //        content: label,
            //        state: "info"
            //    });
            //}
            //else {
            //    if (this.row.vec != null && this.row.vec !== "") {
            //        this.showFlash({
            //            id: "idInitialFlash",
            //            content: "jres:32000952: " + "\"" + this.row.vec + "\"", //RC 32000952 : Věc
            //            state: "info"
            //        });
            //    }
            //    else if (this.row.typ_pozad_pod_txt != null && this.row.typ_pozad_pod_txt !== "") {
            //        this.showFlash({
            //            id: "idInitialFlash",
            //            content: "jres:32000445: " + "\"" + this.row.typ_pozad_pod_txt + "\"", //RC 32000445 : Upřesnění požadavku
            //            state: "info"
            //        });
            //    }
            //}

            const form = $.newDiv("epk-detail-mobile-form").appendTo(this.element);

            const icon = $("<i>")
                .addClass("icon fa fa-info-circle g-state-text g-state-info gflashpanel__icon fa-fw")
                .appendTo(form);

            const container = $.newDiv("container").appendTo(form);

            const vec = $.newDiv("item")
                .html("<div class='bold'>jres:32000952:</div> " + this.row.vec!)
                .appendTo(container);
            const upresneni = $.newDiv("item")
                .html("<div class='bold'>jres:32000967:</div> " + this.row.typ_pozad_pod_txt!)
                .appendTo(container); //RC 32000967 : Upřesnění

            //const Form = new Gordic.Forms.Form({
            //    name: "FormCard",
            //    layoutDescriptor: "L2M2S1, L-12-12-0, M-12-12-0, S-12-12-0"
            //});

            //Form
            //    .addRow("jres:32000952") //RC 32000952 : Věc
            //    .addField("gstringbox", {
            //        name: "vec",
            //        initialValue: this.row.vec
            //    })
            //Form
            //    .addRow("jres:32000445") //RC 32000445 : Upřesnění požadavku
            //    .addField("gstringbox", {
            //        name: "typ_pozad_pod_txt",
            //        initialValue: this.row.typ_pozad_pod_txt
            //    })

            //const form = $.newDiv().appendTo(this.element);
            //form.gform("createFrom", Form);
            //form.gform("viewMode", "view");

        }

        private getStatusbarParams() {

            var params: MenuParams[] = [];

            // colorbar
            params.push({
                customClass: "gcolorbox_status_class",
                id: "statusColor",
                type: "widget",
                tooltip: "jres:32000541",	//RC 32000541 : Barevné označení
                init: () => {
                    var element = $("<div>");
                    element.gcolorpicker({
                        type: "epk",
                        globalSettings: this.globalSettings,
                        readonly: true,
                        uzo: this.row.uzo
                    });
                    return element;
                }
            });

            //if (this.parentContent != null &&
            //    this.parentContent["viewMobileIndex"] != null &&
            //    this.parentContent["viewMobileCount"] != null) {

            //    const index = this.parentContent["viewMobileIndex"];
            //    const count = this.parentContent["viewMobileCount"];

            //    // počítadlo
            //    params.push({
            //        align: "opposite",
            //        customClass: "g-state-text g-state-info",
            //        id: "statusMobileCounter",
            //        type: "static",
            //        caption: String.Format("{0}/{1}", index, count)
            //    });

            //}

            return params;
        }

        private getParams(zpusobVyrizeni: Gordic.Wfl.Interface.GWflczpvEnum, duvodVyrizeni: boolean) {

            this.hideFlash("idFlashVyriditState");

            if (this.vyriditState == null) {
                this.showFlash({
                    id: "idFlashVyriditState",
                    state: "warning",
                    content: "jres:32000674" //RC 32000674 : Nelze provést vyřízení žádosti, není nastaven stav vyřízení.
                });
                return null;
            }

            var params: Wfl.Interface.GEpkCompleteConfigDto = {
                Ixp: this.row.ixp!,
                SerCislo: this.row.ser_cislo!,
                IxsDpo: this.row.ixs_dpo!,
                TypPozadavku: this.vyriditState,
                ZpusobVyrizeni: zpusobVyrizeni,
                DuvodVyrizeni: duvodVyrizeni,
                CasRazitko: this.casoveRazitko.checked,
                CasRazitkoPrilohy: this.casoveRazitkoPriloha.checked, // thazmuka (14.4.2020)
                PodepsatObraz: this.podepsat.checked,
                PodepsatPrilohy: this.podepsatPrilohy.checked,
                PredPodepsanimKonvertovat: this.zkonvertovat.checked,
                ZkonvertovatPrilohy: this.zkonvertovatPrilohy.checked,
                PodepsatPrilohyNePdf: this.podepsatPrilohyNePDF.checked,
                GuidGFRM: ""
            }

            return params;
        }

        /** automacké otevření detailu */
        private autoDetailRun: boolean;

        private selectTypeOfClose() {

            // aktivní automatické otevření dalšího detailu žádosti
            // možné nastavit v možnostech v aplikace
            if (this.autoDetailRun === true) {
                if (this.actions.actListControlsNextRecord != null) {
                    // akce přejít na další detail žádosti je k dispozici
                    var enabled = this.actions.actListControlsNextRecord.enabled();
                    if (enabled === true) {
                        // otevřu další detail žádosti
                        this.actions.actListControlsNextRecord.run();
                        return;
                    }
                }
            }
            // ve výchozím stavu se vrátím na seznam
            this.tryClose();

        }

        private getCommandbarParams() {

            var params: MenuParams[] = [];

            //this.getSettlementParams(params);

            params.push({
                action: this.actions.add(new GAction({
                    name: "actClose",
                    caption: "jres:32000023", //RC 32000023 : Zavřít
                    run: (ev, ctx) => {
                        this.tryClose();
                    }
                }))
            })

            return params;
        }

        private showNahled() {

            var nahled = $("<div class='nahled_class'>")
                .appendTo(this.element);

            nahled
                .gattachment({
                    ixp: this.row.ixp!,
                    ixb_elp: this.row.ixb_elp!,
                    emptyMessage: "jres:32000215",   // RC 32000215 : Dokument nemá elektronický obraz.
                    autofitParentElement: ".ui-dialog-content",
                    serviceContent: "Gordic.Epk.WebControls.GEpkAttachmentService",
                    displayEngineOptions: {
                        pdfEngine: {
                            zoomMode: Gordic.Components.FilePreview.GPdfEngineZoomMode.Height,
                            scrollMode: Gordic.Components.FilePreview.GPdfEngineScrollMode.Horizontal
                        }
                    },
                    filePreviewOptions: {
                        //modifymenubar: (ev, ctx) => {
                        //    new GEpkVisualPlacemenet().setVisualPlacementMenuParams(this, { menuBar: ctx.menuBar, row: this.row, fileSelectionRowFc: () => { return this.fileSelectionRow } });
                        //},
                        customDownload: (input) => {
                            return new Gordic.Epk.WebControls.Sidebar.GEpkAttachment(this).customDownload(input);
                        }
                    },
                    //fileListCustomLocation: filelist,
                    //basePanelOptions: { mode: "vertical" }
                });

        }

        private _load() {
            this.Reload = true;
            return this.load();
        }

    }


}
